module.exports = __webpack_public_path__ + "static/media/94datacomm.97a912c0.png";